<template>
    <div class="sitemap-page">
        <header class="sitemap-hero">
            <div class="sitemap-hero-content">
                <div class="hero-inner">
                    <h1 class="sitemap-title">Plan du site</h1>
                </div>
            </div>
        </header>

        <main class="sitemap-container">
            <section class="sitemap-content">
                <div class="sitemap-grid">

                    <div class="sitemap-category">
                        <h2 class="sitemap-category-title">
                            <i class="fa fa-info-circle"></i> Infos
                        </h2>
                        <ul class="sitemap-links">
                            <li>
                                <router-link :to="{ name: 'cgu' }">
                                    <i class="fa fa-chevron-right"></i> Conditions Générales d'Utilisation
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'faq' }">
                                    <i class="fa fa-chevron-right"></i> FAQ — Questions fréquentes
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'contact' }">
                                    <i class="fa fa-chevron-right"></i> Contact
                                </router-link>
                            </li>
                        </ul>
                    </div>

                    <div class="sitemap-category">
                        <h2 class="sitemap-category-title">
                            <i class="fa fa-compass"></i> Découvrir
                        </h2>
                        <ul class="sitemap-links">
                            <li>
                                <router-link :to="{ name: 'about' }">
                                    <i class="fa fa-chevron-right"></i> Qui sommes-nous ?
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'conduct-charter' }">
                                    <i class="fa fa-chevron-right"></i> Charte de bonne conduite
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'map' }">
                                    <i class="fa fa-chevron-right"></i> Carte Interactive
                                </router-link>
                            </li>
                        </ul>
                    </div>

                    <div class="sitemap-category">
                        <h2 class="sitemap-category-title">
                            <i class="fa fa-ellipsis-h"></i> Plus
                        </h2>
                        <ul class="sitemap-links">
                            <li>
                                <router-link :to="{ name: 'concept' }">
                                    <i class="fa fa-chevron-right"></i> Notre Concept
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'cookies' }">
                                    <i class="fa fa-chevron-right"></i> Utilisation des cookies
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'sitemap' }">
                                    <i class="fa fa-chevron-right"></i> Plan du site
                                </router-link>
                            </li>
                        </ul>
                    </div>

                    <div class="sitemap-category">
                        <h2 class="sitemap-category-title">
                            <i class="fa fa-user"></i> Mon compte
                        </h2>
                        <ul class="sitemap-links">
                            <li>
                                <router-link :to="{ name: 'login' }">
                                    <i class="fa fa-chevron-right"></i> Connexion
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'register' }">
                                    <i class="fa fa-chevron-right"></i> Inscription
                                </router-link>
                            </li>
                        </ul>
                    </div>

                    <div class="sitemap-category">
                        <h2 class="sitemap-category-title">
                            <i class="fa fa-car"></i> Covoiturage
                        </h2>
                        <ul class="sitemap-links">
                            <li>
                                <router-link :to="{ name: 'trips' }">
                                    <i class="fa fa-chevron-right"></i> Rechercher un trajet
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'new-trip' }">
                                    <i class="fa fa-chevron-right"></i> Proposer un trajet
                                </router-link>
                            </li>
                        </ul>
                    </div>

                </div>
            </section>
        </main>

        <footer class="footer-section">
            <div class="footer-container">
                <div class="footer-left">
                    <div class="footer-logo-section">
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar Logo" class="footer-logo" />
                        <span class="footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="footer-social-links">
                        <a href="#" class="social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-center">
                    <div class="footer-column">
                        <h4 class="footer-column-title">Infos</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Decouvrir</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'about' }">Qui sommes-nous ?</router-link></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Plus</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">Plan du site</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <p class="footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits reserves.
                </p>
            </div>
        </footer>
    </div>
</template>

<style>
.app-container.sitemap,
.app-container.sitemap main,
.app-container.sitemap #main {
    min-height: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.sitemap .view-container {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.sitemap .footer-component {
    display: none !important;
}
</style>

<style scoped>
.sitemap-page {
    background: #f6f9f7;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.sitemap-hero {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #fff;
    padding: 80px 20px 60px;
    text-align: center;
}

.sitemap-hero-content {
    width: min(1400px, 96vw);
    margin: 0 auto;
}

.hero-inner {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
}

.sitemap-title {
    margin: 0;
    font-size: 48px;
    line-height: 1.2;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: -0.5px;
}

.sitemap-container {
    width: min(1200px, 96vw);
    margin: 0 auto;
    padding: 54px 16px 28px;
    flex: 1;
}

.sitemap-content {
    background: #fff;
    border: 1px solid #e3ebe5;
    border-radius: 10px;
    padding: 44px 52px;
    box-shadow: 0 2px 7px rgba(0, 0, 0, 0.04);
}

.sitemap-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem 3rem;
}

.sitemap-category {
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
}

.sitemap-category-title {
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: #1f3f2e;
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 2px solid #e3ebe5;
    display: flex;
    align-items: center;
    gap: 8px;
}

.sitemap-category-title i {
    color: #2d5016;
    font-size: 16px;
}

.sitemap-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
}

.sitemap-links li a {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-family: 'Heebo', 'Poppins', sans-serif;
    color: #34463c;
    text-decoration: none;
    transition: color 0.2s ease;
}

.sitemap-links li a:hover {
    color: #2d5016;
    text-decoration: underline;
}

.sitemap-links li a i {
    font-size: 11px;
    color: #2d5016;
    flex-shrink: 0;
}

/* Footer */
.footer-section {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 1.5rem;
    margin-bottom: 0 !important;
    padding: 3rem 1rem 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.social-link i {
    font-size: 1.25rem;
}

.footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-links li {
    margin: 0;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 0;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

@media (max-width: 1024px) {
    .footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }

    .sitemap-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .sitemap-hero {
        padding: 50px 20px 40px;
    }

    .sitemap-title {
        font-size: 32px;
    }

    .sitemap-container {
        padding: 34px 12px 28px;
    }

    .sitemap-content {
        padding: 28px 24px;
    }

    .sitemap-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 2rem;
    }

    .footer-section {
        padding: 2rem 1rem 100px;
        margin-top: 1rem;
    }

    .footer-left {
        gap: 1.5rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .footer-column {
        gap: 0.75rem;
    }

    .footer-column-title {
        font-size: 1rem;
    }

    .footer-links a {
        font-size: 0.9rem;
    }

    .footer-logo {
        width: 40px;
        height: 40px;
    }

    .footer-brand-name {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .sitemap-hero {
        padding: 40px 20px 30px;
    }

    .sitemap-title {
        font-size: 26px;
    }

    .sitemap-container {
        padding: 24px 12px;
    }

    .sitemap-content {
        padding: 20px 16px;
    }

    .sitemap-grid {
        grid-template-columns: 1fr;
        gap: 1.75rem;
    }
}
</style>

<script>
import router from '../../router';
import bus from '../../services/bus-event.js';

export default {
    name: 'sitemap',
    methods: {
        onBackClick() {
            router.back();
        }
    },
    mounted() {
        bus.on('back-click', this.onBackClick);
    },
    beforeDestroy() {
        bus.off('back-click', this.onBackClick);
    }
};
</script>
